export default __webpack_public_path__ + "static/media/illustration-work-2-m.b25a4fd0.webp";